import { useRecoProducts } from '@digital-retail/recommended-products';
import { useMemo, useState } from 'react';
import { getTenantValue } from '../../containers/ProdctSpecifications/BuyTogether/constants';
import { getContextIdFromCookie, getUserIdFromCookieOrRutHash, getWidgetsApiParams } from '../../utils/RecoHelper';
import { DEFAULT_GROUP_ID } from './constants';
import { buildViewMoreUrl, mapGroupNames } from './pillsButtonCarouselUtils';
import { usePillsButtonMetricsHook } from './usePillsButtonMetricsHook';

const usePillsButtonCarouselHook = ({ appCtx, product, rutHash }) => {
  const { deviceType } = appCtx;
  const siteName = getTenantValue(appCtx.store, appCtx.regionCode);
  const pillsButtonConfig = useMemo(
    () => appCtx.siteConfig?.configurations?.pdpPillsButtonConfig || {},
    [appCtx.siteConfig?.configurations?.pdpPillsButtonConfig]
  );
  const carouselConfig = {
    ...pillsButtonConfig,
    recoParams: getWidgetsApiParams({
      appCtx,
      product,
      slots: pillsButtonConfig.slotId,
      widgetsUUID: '',
      userId: getUserIdFromCookieOrRutHash(appCtx, rutHash),
      contextId: getContextIdFromCookie(appCtx),
      channel: pillsButtonConfig.channel,
      groupId: DEFAULT_GROUP_ID,
    }),
  };
  const [shouldLoadData, setShouldLoadData] = useState(false);
  const recoProducts = useRecoProducts({
    shouldLoad: shouldLoadData,
    params: carouselConfig.recoParams,
    isStandaloneSite: true,
    minTabs: carouselConfig.minGroups,
    maxTabs: carouselConfig.maxGroups,
  });
  const mappedGroups = useMemo(() => {
    return mapGroupNames({ groups: recoProducts.groups, ...pillsButtonConfig });
  }, [recoProducts.groups, pillsButtonConfig]);
  const isDefaultGroup = recoProducts.selectedGroup?.groupId === DEFAULT_GROUP_ID;
  const minRequiredPods = isDefaultGroup ? 1 : carouselConfig.minPods;
  const hasProducts = recoProducts.products?.length >= minRequiredPods;
  const showMore = hasProducts && !isDefaultGroup && !recoProducts.isLoading;
  const viewMoreUrl = buildViewMoreUrl({ appCtx, currentGroup: recoProducts.selectedGroup });
  const { groupAnalytics, carouselAnalytics } = usePillsButtonMetricsHook({
    carouselName: recoProducts.carouselName,
    slotId: carouselConfig.slotId,
    siteName,
    currentGroup: recoProducts.selectedGroup,
    groups: mappedGroups,
    products: recoProducts.products,
    pageId: product.currentVariant,
  });

  const handleVisible = () => {
    setShouldLoadData(true);
  };

  const onClickGroupId = (groupId) => {
    recoProducts.onGroupSelect(groupId);
  };

  return {
    deviceType,
    groupAnalytics,
    carouselAnalytics,
    recoProducts,
    groups: mappedGroups,
    onClickGroupId,
    handleVisible,
    products: recoProducts.products,
    carouselConfig,
    viewMoreUrl,
    hasProducts,
    showMore,
  };
};

export { usePillsButtonCarouselHook };
